import { __decorate } from "tslib";
import { Component, Model, Vue } from 'vue-property-decorator';
let BeeCheckbox = class BeeCheckbox extends Vue {
    constructor() {
        super(...arguments);
        this.svgTransform = "";
        this.colors = this.$store.getters.colors;
    }
    changeValue() {
        this.$emit('change', !this.checked);
    }
    // get txtColor() {
    // 	return `fill: ${this.colors.textColor};`
    // }
    get txtColor() {
        return `fill: #fff;`;
    }
    mounted() {
        const svg = this.$refs.svg;
        const originalHeight = 245;
        // const originalWidth = 292
        const scale = (svg.clientHeight * 0.5) / originalHeight;
        const x = -(svg.clientWidth / 2) * 0.0;
        const y = (svg.clientHeight / 2) * 0.3;
        this.svgTransform = `translate(${x},${y}) scale(${scale})`;
    }
    created() {
        this.$emit('change', false);
    }
};
__decorate([
    Model('change', { type: Boolean })
], BeeCheckbox.prototype, "checked", void 0);
BeeCheckbox = __decorate([
    Component
], BeeCheckbox);
export default BeeCheckbox;
